import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Schoolviewtile } from '../models/schoolviewtile.model';
import { Schooladminitem } from '../models/school/schooladminitem.model';
import { Observable } from 'rxjs';
import { moduledetails } from '../models/module/moduledetails';
import { SchoolPackageViewTile } from '../models/schoolpackageviewtile.model';
import { Moduleviewtile } from '../models/school/moduleviewtile.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolPackageService {
  enrollforpackage(id: any) {
    return this.http.post(
      this.rootURL + `schoolpackages/enrollforpackage?packageId=${id}`,
      id
    );
  }

  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly headers = {'Content-Type': 'application/json', 'accept': 'application/json'};
  constructor(private http: HttpClient) { }

  getSchoolPackages(){
    const url = `${this.rootURL}schoolpackages/getschoolpackages`;
    return this.http.get<SchoolPackageViewTile[]>(url);
  }

  getSchoolPackage(id: number){
    const url = `${this.rootURL}schoolpackages/getschoolpackage?id=${id}`;
    return this.http.get<SchoolPackageViewTile>(url);
  }

  getSchoolPackageModules(packageId: number, exists: boolean){
    const url = `${this.rootURL}schoolpackages/getschoolpackagemodules?schoolPackageId=${packageId}&exists=${exists}`;
    return this.http.get<Moduleviewtile[]>(url);
  }

  userIsSchoolPackageStudent(packageId: number){
    const url = `${this.rootURL}schoolpackages/isschoolpackagestudent?schoolPackageId=${packageId}`;
    return this.http.get<boolean>(url);
  }

  createPackage(modulePackage: SchoolPackageViewTile){
    const url = `${this.rootURL}schoolpackages/create`
    return this.http.post<SchoolPackageViewTile>(url, modulePackage, {headers: this.headers});
  }

  addPackageModule(packageId: number, moduleId: number){
    const url = `${this.rootURL}schoolpackages/addmodule`;
    return this.http.post<moduledetails>(url, { schoolPackageId: packageId, schoolModuleId: moduleId }, {headers: this.headers});
  }

  removePackageModule(packageId: number, moduleId: number){
    const url = `${this.rootURL}schoolpackages/removemodule`
    return this.http.post(url, {schoolPackageId: packageId, schoolModuleId: moduleId}, {headers: this.headers});
  }

  deletePackage(packageId: number){
    const url = `${this.rootURL}schoolpackages/delete`;
    return this.http.post(url, { schoolPackageId: packageId }, {headers: this.headers});
  }

  uploadPackageLogo(packageId: number, file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      this.rootURL + `schoolpackages/updatepackagelogo?packageid=${packageId}`,
      formData
    );
  }
}
